import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSub = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	focusable: "false",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#E9FF03",
			d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z",
			role: "img",
			"aria-label": "Switch player"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C0020D",
			d: "M6 8.444a.427.427 0 0 1-.32-.16L2.758 4.857a.606.606 0 0 1 .042-.7.408.408 0 0 1 .597-.05L6 7.16l2.603-3.052a.408.408 0 0 1 .597.05c.16.188.178.487.042.7L6.32 8.284c-.085.1-.2.158-.32.16Z",
			"aria-hidden": "true"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#009A4C",
			d: "M12.886 12.004a.425.425 0 0 1-.318-.159L9.98 8.825l-2.587 3.02a.407.407 0 0 1-.593-.049.597.597 0 0 1-.043-.692l2.906-3.392a.409.409 0 0 1 .635 0l2.905 3.392a.597.597 0 0 1 .096.572c-.07.196-.232.325-.413.328Z",
			"aria-hidden": "true"
		})
	]
});
export default SvgSub;
